import { render } from "./NavbarPCZ.vue?vue&type=template&id=35986aba"
import script from "./NavbarPCZ.vue?vue&type=script&lang=js"
export * from "./NavbarPCZ.vue?vue&type=script&lang=js"

import "./NavbarPCZ.vue?vue&type=style&index=0&id=35986aba&lang=css"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__